<template>
    <q-table
        ref="table"
        :data="registrations"
        :columns="columns_registrations"
        row-key="id"
        :pagination.sync="server_pagination"
        @request="requestRegistrations"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5, 10, 50, 100]"
        binary-state-sort
        class="q-mt-lg"
    >
        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>
        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="full_name" :props="props">
                    {{ props.row.full_name }}
                </q-td>

                <q-td key="email" :props="props">
                    {{ props.row.email }}
                </q-td>

                <q-td key="subscription_date" :props="props">
                    {{ fDate(props.row.subscription_date) }}
                </q-td>
            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {
    name: 'TrainingReportRegistrations',
    props: ['load', 'id'],
    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            registrations: [],
            columns_registrations: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: true
                },
                {
                    name: 'subscription_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'subscription_date',
                    sortable: true
                }
            ],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return (headers = {
                headers: {
                    'content-type': 'application/json',
                    authorization: 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    authorization: 'Bearer ' + this.access_token
                }
            })
        }
    },

    methods: {
        requestRegistrations({ pagination }) {
            this.registrations = []
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                page_size: this.server_pagination.rowsPerPage,
                page: this.server_pagination.page,
                ordering: order_by
            }

            this.savePagination()

            this.$axios
                .get(`/admin_group_trainings/group_trainings/${this.id}/group_training_users_subscribed/?${this.$qs.stringify(data)}`, this.getHeader)
                .then((res) => {
                    this.server_pagination.rowsNumber = res.data.count

                    res.data.results.map((e) => {
                        this.registrations.push(e)
                    })

                    this.loading = false
                })
                .catch((e) => {
                    this.loading = false
                    console.log(e)
                })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch (this.id_user_language_selected) {
                    case 1:
                    case 3:
                        format = 'DD/MM/YYYY HH:mm:ss'
                        break
                    default:
                        format = 'MM-DD-YYYY HH:mm:ss'
                        break
                }

                return date.formatDate(d, format)
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestRegistrations({ pagination: this.server_pagination })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()
        this.requestRegistrations({ pagination: this.server_pagination })
    }
}
</script>

<style></style>
